import { render, staticRenderFns } from "./RelatorioInspecaoModal.vue?vue&type=template&id=63dbbfee&scoped=true"
import script from "./RelatorioInspecaoModal.vue?vue&type=script&lang=js"
export * from "./RelatorioInspecaoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dbbfee",
  null
  
)

export default component.exports